import { connect } from 'react-redux'
import { createSelector } from 'reselect'

// Actions
import { actions as profileActions } from 'modules/profile/actions'

// Components
import { Link } from '@tracklib/kit'
import InviteForm from 'components/base/inviteform'

// Selectors
import { invitesEntities } from 'selectors'

// Types
import type { Dispatch } from 'types'

import styles from './heroinvitefriendsblock.css'

type HeroInviteFriendsBlockProps = {
  alreadyInvitedEmails: Array<string>
  value: {
    title: string
    body?: string
    input_placeholder: string
    input_button_text: string
    link_text?: string
    link_url?: string
  }
  sendInvite: (email: string) => void
}

const HeroInviteFriendsBlock = ({
  alreadyInvitedEmails,
  value: { title, body, input_placeholder, input_button_text, link_text, link_url },
  sendInvite,
}: HeroInviteFriendsBlockProps): JSX.Element => (
  <div>
    <div className={styles.wrapper}>
      <section>
        <div>
          <h1 className={styles.title}>{title}</h1>
          {body && <p className={styles.body}>{body}</p>}
          <InviteForm
            onSubmit={(data: { email: string }) => sendInvite(data.email)}
            placeholder={input_placeholder}
            buttonText={input_button_text}
            alreadyInvitedEmails={alreadyInvitedEmails}
          />
          {link_text && (
            <Link to={link_url} className={styles.link}>
              {link_text}
            </Link>
          )}
        </div>
      </section>
    </div>
  </div>
)

const mapStateToProps = createSelector([invitesEntities], invites => {
  const inviteList = Object.keys(invites).map(id => invites[id])
  return {
    alreadyInvitedEmails: inviteList.map(inv => inv.email),
  }
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  sendInvite: (email: string) => dispatch(profileActions.sendInvite(email)),
})

export { HeroInviteFriendsBlock as Component }
export default connect(mapStateToProps, mapDispatchToProps)(HeroInviteFriendsBlock)
